import { render } from "./ChromeNotificationPage.vue?vue&type=template&id=7cd013f5"
import script from "./ChromeNotificationPage.vue?vue&type=script&lang=js"
export * from "./ChromeNotificationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__